export enum TokenOrderingEnum {
  EXPIRATION_DATE = "EXPIRATION_DATE",
  HIGHEST_AMOUNT = "HIGHEST_AMOUNT",
  LOWER_AMOUNT = "LOWER_AMOUNT",
  CREATION_DATE = "CREATION_DATE",
}
